// function onScroll(event){
//     var scrollPos = $(document).scrollTop();
//     $('.nav a').each(function () {
//         e.preventDefault();
//         var currLink = $(this);
//         var refElement = $(currLink.attr("href"));
//         var topElement = refElement.position().top - 120;
//         if (topElement <= scrollPos && refElement.position().top + refElement.height() > scrollPos) {
//             $('ul.nav li a').removeClass("active");
//             currLink.addClass("active");
//         }
//         else{
//             currLink.removeClass("active");
//         }
//     });
// }

function onScroll(event){
  var scrollPos = $(document).scrollTop();
  $('#bs-example-navbar-collapse-1 a').each(function () {
    var currLink = $(this);
    var refElement = $(currLink.attr("href").replace('/preprod', '').substring(1));
    if(refElement.position()){
      var topElement = refElement.position().top - 120;
      if (topElement  <= scrollPos && refElement.position().top + refElement.height() > scrollPos) {
          $('#bs-example-navbar-collapse-1 ul li a').removeClass("active");
          currLink.addClass("active");
      }
      else{
          currLink.removeClass("active");
      }
    }
  });
}

module.exports = function () {


  $(document).on("scroll", onScroll);

  //smoothscroll
  $('a[href^="#"]').not('[href="#magCarousel"]').on('click', function (e) {
      e.preventDefault();
      $(document).off("scroll");

      $('a').each(function () {
          $(this).removeClass('active');
      })
      $(this).addClass('active');

      var target = this.hash,
          menu = target;
      $target = $(target);
      $('html, body').stop().animate({
          'scrollTop': $target.offset().top
      }, 500, 'swing', function () {
          window.location.hash = target;
          $(document).on("scroll", onScroll);
      });
  });

  $('#nav-icon4').click(function(){
		$(this).toggleClass('open');
	});
  var navMain = $(".navbar-collapse");
  navMain.on("click", "a:not([data-toggle])", null, function () {
      navMain.collapse('hide');
      $('#nav-icon4').toggleClass('open');
  });

  return true
};



//////////////////
// WEBPACK FOOTER
// ./app/shared/js/navbar.js
// module id = 3
// module chunks = 0 1 2